import { ModuleWithProviders, NgModule} from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { SessionStorageService } from './session-storage.service';

@NgModule({
    providers: [ LocalStorageService, SessionStorageService ]
})
export class StorageModule {
    public static forRoot( namespace: string ): ModuleWithProviders<any> {
        return {
            ngModule: StorageModule,
            providers: [
                { provide: 'StorageNamespace', useValue: namespace }
            ]
        };
    }
}
